module.exports = __webpack_public_path__ + "static/media/img-3-fr.efef6f1f.webp";